<template>
  <div class="cmp-catalog-artist-artist_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddArtistsClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search">
        <InputField
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
    </div>

    <div class="dt-page--body">
      <NTable
        id="catalog-artist-artist_list"
        class="h1"
        :config="tableConfig"
        :headers="contactHeaders"
        :items="list"
        @scrollnext="onArtistNext"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr @click="onArtistClicked(item)">
            <td v-bind="tdcon('artist')">
              <span style="font-weight: 800">{{ item["artist_name"] }}</span>
            </td>
            <td v-bind="tdcon('url1')">
              <span>{{ item["url1"] }}</span>
            </td>

            <td v-bind="tdcon('amg_id')">
              <span>{{ item["amg_id"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img
                  @click.stop="(e) => deleteArtists(item)"
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s2"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <Sidewindow
      :navConfig="defaultConfig"
      :value="artistsDetailsFlag"
      @closed="onCloseReleaseDetails"
    >
      <ArtistSidewindow />
      <!-- <ReleaseSidewindow /> -->
    </Sidewindow>

    <ModalContainer :modalKey="'createCatalogArtists'" :width="'420'">
      <CreateArtists @addArtists="addArtists" @cancelled="closeModal" />
    </ModalContainer>

    <!-- <ModalContainer :modalKey="'advanceSearch'" :width="'420'">
        <AdvanceSearch  v-if="releasesCatalogData" :labels='labels' :statuses='statuses ' @cancelled="closeModal" />
    </ModalContainer> -->

    <!-- <v-navigation-drawer
        v-bind="defaultConfig"
        :value="contactDetailsFlag"
        touchless
      >
      <ContactSidewindow
        :selectedContact="selectedContact"
        @closeContactSidewindow="onCloseContactSidewindow"
        @fetch="onContactFetch"
      ></ContactSidewindow>

    </v-navigation-drawer>-->
    <!-- <Sidewindow
      :value="contactDetailsFlag"
      @closed="onCloseContactSidewindow"
    >
      <ContactSidewindow
        :selectedContact="selectedContact"
        @fetch="onContactFetch"
      ></ContactSidewindow>
    </Sidewindow> -->

    <!-- <template v-if="advancedSearchModalContainer">
      <v-dialog
        v-model="advancedSearchModal"
        persistent
        width="550"
      >
        <AdvancedSearch
          :groupsTV="groupsTV"
          :countriesTV="countriesTV"
          :searchConfig="searchConfig"
          @search="onAdvancedSearch"
          @export="onAdvancedSearchExport"
          @create_group="onAdvancedSearchCreateGroup"
          @cancelled="onAdvancedSearchCancelled"
        />
      </v-dialog>
    </template> -->
  </div>
</template>

<script>
import { CatalogStoreNamespace as storeNS } from "../../store";
import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";
import { mapGetterObject, mapActionObject } from "../../../../store/global";

import {
  catalogArtistListLDTRoutes,
  getArtistsDetailsSelectable,
} from "../../router/routes";

import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import { subscribeSubject } from "../../../../utility";
import { artistsCatalogActions } from "../../store/artists/actions";
import { artistsCatalogGetters } from "../../store/artists/getters";
import CreateArtists from "./create-artists";
import { artistsService } from "../../services/artists/artists.service";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import ArtistSidewindow from "./artist-sidewindow";
import { async } from "ramda-adjunct";

const LDTConfig = {
  entityName: "artist",
  ldtRoutes: catalogArtistListLDTRoutes,
  detailsSelectableFunction: getArtistsDetailsSelectable,
  primaryKey: "label_artist_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.CatalogArtistsDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.CatalogArtistsDetails.FETCH.SINGLE,
};

export default {
  components: {
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
    Sidewindow,
    CreateArtists,
    ArtistSidewindow,
  },
  mounted: function () {
    this.fetchList();
    subscribeSubject(this, this.subjectSearchSubject, (searchString) => {
      console.log("STRING SER", searchString);

      const resData = artistsService.searchArtists(searchString).then((res) => {
        console.log("SEARCH DATA", res);
        this.searchResult = res.data.all_artists;
      });
    }),
      subscribeSubject(this, this.scrollSubject$, (scrollTop) => {
        this[ActionTypes.ArtistsCatalogListData.SET.ALL]({});
      });
  },
  data: function () {
    return {
      //startRow: 0,
      subjectSearchSubject: new Subject(),
      searchResult: [],
      searchString: "",
      defaultConfig: defaultConfig,
      scrollSubject$: new Subject(),

      loadingFlag: false,
    };
  },
  mixins: [createModalMixin("createCatalogArtists"), createLDTHost(LDTConfig)],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetterObject(storeNS, artistsCatalogGetters),

    artistsDetailsFlag: function () {
      return childOfOrEqualDetails(catalogArtistListLDTRoutes, this.$route);
    },

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      console.log("LIST ARTIST", this.artistsList);
      if (this.artistsList && this.searchString.length == 0) {
        return this.artistsList;
      } else {
        return this.searchResult;
      }
      return [];
    },

    contactHeaders: function () {
      return [
        createTableHeader("artist", {}),
        createTableHeader("url1", {}),
        createTableHeader("amg_id", {}),

        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
  },
  methods: {
    ...mapActionObject(storeNS, artistsCatalogActions),

    fetchData: function () {
      this[ActionTypes.ArtistsCatalogData.FETCH.ALL]();
    },
    async fetchList() {
      this.loadingFlag = true;
      await this[ActionTypes.ArtistsCatalogData.FETCH.ALL]();
      this.loadingFlag = false;
    },

    searchContactFiles: function (key) {
      this[ActionTypes.ContactFilesSearchResult.FETCH.ALL](key);
    },

    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;

      this.subjectSearchSubject.next(this.searchString);
    },
    onAddArtistsClick: function () {
      console.log("WEEEEEEEEEEE", { ...this.$route });

      this.$router.push({
        ...this.$route,
        query: {
          modal: "create_catalog_artists",
        },
      });
    },
    addArtists: function (payload) {
      this[ActionTypes.ArtistsCatalogListData.INSERT.SINGLE](payload);
      this.closeModal();
    },

    onArtistNext: function (value) {
      this.scrollSubject$.next(value);
    },
    closeModal: function () {
      closeModalRoute(this);
    },
    onCloseReleaseDetails: function () {
      handleFromRoute(this, () => {
        this.$router.push({
          name: catalogArtistListLDTRoutes.names.list,
        });
      });
    },

    deleteArtists: async function (item) {
      // ConfirmationService.create({
      //   subject: "Do you really want to delete this Artist?",
      //   model: true,
      //   width: 500,
      //   results: [
      //     createConfirmResult({
      //       value: "yes",
      //       text: "Yes",
      //       classes: ["v1"]
      //     }),
      //     createConfirmResult({
      //       value: "No"
      //     })
      //   ],
      //   completed: res => {
      //     switch (res) {
      //       case "yes":
      //         this[ActionTypes.ArtistsCatalogListData.DELETE.SINGLE](item);
      //         break;
      //       default: {
      //       }
      //     }
      //   }
      // });
      const confirmationResult = await confirmDelete(
        "Artist",
        item.artist_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.ArtistsCatalogListData.DELETE.SINGLE](item);
      }
    },

    onArtistClicked: function (artist) {
      //this.selectedClickedProduct = product;
      this.$router.push({
        name: catalogArtistListLDTRoutes.names.tab,
        params: {
          label_artist_id: artist.label_artist_id,
          tab: "overview",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-artist-artist_list {
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;

  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>
